import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import withTranslate from '../../hoc/with-translate';
import BackButton from '../../containers/back-button';
import { ArrowBackIcon } from '../../components/icons';
import styles from './header-back-button.scss';

const HeaderBackButton = ({ text, t }) => {
  return (
    <BackButton className={classNames(styles.button, 'header-back-button')}>
      <span className={styles.wrapper}>
        <ArrowBackIcon className="button-primary-icon-fill"/>
        <span>
          <span className={classNames(styles.label, 'button-primary-text-color')}>
            {text && t(text)}
          </span>
        </span>
      </span>
    </BackButton>
  );
};

HeaderBackButton.propTypes = {
  text: PropTypes.string,
  t: PropTypes.func,
};

HeaderBackButton.defaultProps = {
  text: 'header-back-button.back',
};

export default withTranslate(HeaderBackButton);



// WEBPACK FOOTER //
// ./app/components/header-back-button/header-back-button.js